package br.com.texeratx.boardgametimeapp.domain.usecases.expansions

import br.com.texeratx.boardgametimeapp.data.model.expansion.ExpansionDTO
import br.com.texeratx.boardgametimeapp.data.repository.ExpansionRepository

class GetExpansionByIdUseCase(
    private val repo: ExpansionRepository
) {
    suspend operator fun invoke(id: Long): Result<ExpansionDTO> = repo.getExpansionById(id)
}
